import React from 'react';
/*@begin-app-target*/import { AppContent } from '../app-browse/app-content';/*@end-app-target*/

import '@csstools/normalize.css/normalize.css'
import { BwjNavigationWarning } from '../framework/components/bwj-navigation-warning';
import { BwjToastProvider } from '../framework/components/bwj-toast/context';

export const App: React.FunctionComponent = () => {

  return (
    <BwjToastProvider>
      <BwjNavigationWarning />
      <AppContent />
    </BwjToastProvider>
  );
};
